import React, {useState, useEffect} from 'react';
import { BlobServiceClient } from '@azure/storage-blob';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PublishIcon from '@material-ui/icons/Publish';
import { v4 as uuidv4 } from 'uuid';
import users from '../services/user';

const useStyles = makeStyles((theme) => ({
  required: {
    '&:after': {
      content: "''",
      top: 0,
      color: '#e32',
      marginLeft: 5
    }
  },
  formControl: {
    width: '80%',
    padding: '20px 0',
    textAlign: 'left',
    '& h4': {
      fontSize: 18,
      lineHeight: '18px',
      margin: ' 0 0 10px',
      color: '#949494',
      fontWeight: '400',

    },
    '& >p': {
      fontSize: 12,
      margin: '0 0 10px',
      color: '#949494',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    }
  },
  uploadFile: {
    position: 'relative',
    border: '1px solid #007c9d',
    padding: 10,
    borderRadius: 5,
    width: 160,
    cursor: 'pointer',
    '& svg': {
      color: '#007c9d',
      margin: '0 10px 0 0'
    },
    '& p': {
      margin: 0,
      color: '#007c9d',
      fontSize: 16,
      textTransform: 'uppercase',
      fontWeight: '700',
      display: 'flex',
      alignItems: 'flex-end',
    }
  },
  fileInput: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    opacity: 0,
    '& div': {
      height: '100%'
    },
    '& input': {
      height: '100%',
      padding:0
    }
  },
  uploadContainer:{
    display: 'flex',
    alignItems: 'center',
    padding: '20px 0 0',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems:'flex-start'
    }
  },
  uploadedFile:{
    padding: '0 30px',
    fontSize: 14,
    color: '#000',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: 300,
    [theme.breakpoints.down('xs')]: {
      padding: '20px 0 0',
      width:'100%',
      maxWidth: 250
    }
  }
}));

export const FileInput = ({ name, required, onChange, label, hintText, defaultValue, ...restProps }) => {
  const [fileName, setFileName] = useState('')
  const [imgUrl, setImgUrl] = useState('')
  
  useEffect(()=> {
    if (defaultValue) {
      setImgUrl(defaultValue)
      onChange({ target: { name: name, value: defaultValue } })
    }
  },[])


  let myref = null;
  const classes = useStyles();
  async function uploadFileToAzure(selectedFile) {
    let fileType = selectedFile.name;
    fileType = fileType.split('.');
    let modifiedFileName = uuidv4().split('-').join('');
    if(fileType && fileType.length > 0){
      modifiedFileName = `${modifiedFileName}.${fileType[1]}`
    }else{
      modifiedFileName = `${modifiedFileName}.png`
    }
    setFileName(modifiedFileName)
    // const blobServiceClient = new BlobServiceClient(
    //   `${process.env.REACT_APP_AZURE_STORAGE_URL}${process.env.REACT_APP_AZURE_STORAGE_SAS_KEY}`
    // );
    // const containerClient = blobServiceClient.getContainerClient(
    //   process.env.REACT_APP_AZURE_CONTAINER_NAME
    // );
    // const blockBlobClient = containerClient.getBlockBlobClient(
    //   selectedFile ? modifiedFileName : ''
    // );
    // let azureImageUrl = ''
    
    try {
      // await blockBlobClient
      //   .uploadBrowserData(selectedFile, {
      //     concurrency: 20, // 20 concurrency
      //     onProgress: ev => console.log(ev)
      //   }).then(() => {
      //     azureImageUrl = `${process.env.REACT_APP_AZURE_STORAGE_URL}/${process.env.REACT_APP_AZURE_CONTAINER_NAME}/${selectedFile ? modifiedFileName : ''}`;
      //     onChange({ target: { name: name, value: azureImageUrl } })
      //     setImgUrl(azureImageUrl)
      //   })
      
      const formData = new FormData();
      formData.append("document", selectedFile, modifiedFileName);
      const response = await users.uploadFile(formData);
      const { fileUrl } = response.data
      onChange({ target: { name: name, value: fileUrl } })
      setImgUrl(fileUrl)
      
    } catch (err) {
      console.error(
        `uploadFile failed,${err?.message}`
      );
    }
  }

  const onFileSelected = (e) => {
    e.preventDefault();
    uploadFileToAzure(e.target.files[0])
  }

  const handleBrowse = function (e) {
    e.preventDefault();
    myref.click();
  };

  return (
    <div className={classes.formControl}>
      <h4 className={label ? classes.required : ''}>{label}</h4>
      <p>{hintText}</p>
      <div className={classes.uploadContainer}>
      <div className={classes.uploadFile}>
        <p><PublishIcon /> Upload File </p>
        <div style={{display: 'flex', flexDirection: 'row'}}>
        <TextField {...!imgUrl ? {required: true} : {required: false} } className={classes.fileInput} name={name} {...restProps} id='logo-input' ref={(r) => { myref = r }} type='file' onChange={onFileSelected} />
        </div>
      </div>
      <div className={classes.uploadedFile}>{fileName}</div>
      {imgUrl && <img style={{width: 20, height: 20}} src={imgUrl}/>}
      </div>
    </div>
  );
}

export const FileInputV2 = ({ name, required, onChange, label, hintText, defaultValue, ...restProps }) => {
  const [fileName, setFileName] = useState('')
  const [imgUrl, setImgUrl] = useState('')
  
  useEffect(()=> {
    if (defaultValue) {
      setImgUrl(defaultValue)
      onChange({ target: { name: name, value: defaultValue } })
    }
  },[])


  let myref = null;
  const classes = useStyles();
  async function uploadFileToAzure(selectedFile) {
    let fileType = selectedFile.name;
    fileType = fileType.split('.');
    let modifiedFileName = uuidv4().split('-').join('');
    if(fileType && fileType.length > 0){
      modifiedFileName = `${modifiedFileName}.${fileType[1]}`
    }else{
      modifiedFileName = `${modifiedFileName}.png`
    }
    setFileName(modifiedFileName)  
    try {
      const formData = new FormData();
      formData.append("document", selectedFile, modifiedFileName);
      const response = await users.uploadFile(formData);
      const { fileUrl } = response.data
      onChange({ target: { name: name, value: fileUrl } })
      setImgUrl(fileUrl)
      
    } catch (err) {
      console.error(
        `uploadFile failed,${err?.message}`
      );
    }
  }

  const onFileSelected = (e) => {
    e.preventDefault();
    uploadFileToAzure(e.target.files[0])
  }

  const handleBrowse = function (e) {
    e.preventDefault();
    myref.click();
  };

  return (
    <div className={classes.formControl}>
      <h4 className={label ? classes.required : ''}>{label}</h4>
      <p>{hintText}</p>
      <div className={classes.uploadContainer}>
      <div className={classes.uploadFile}>
        <p><PublishIcon /> Upload File </p>
        <div style={{display: 'flex', flexDirection: 'row'}}>
        <TextField {...!imgUrl ? {required: false} : {required: false} } className={classes.fileInput} name={name} {...restProps} id='logo-input' ref={(r) => { myref = r }} type='file' onChange={onFileSelected} />
        </div>
      </div>
      <div className={classes.uploadedFile}>{fileName}</div>
      {imgUrl && <img style={{width: 20, height: 20}} src={imgUrl}/>}
      </div>
    </div>
  );
}
